// extracted by mini-css-extract-plugin
export default {"modal_body":"Modaldata_modal_body__9ZHNy","form_data":"Modaldata_form_data__oYlWq","dropdown_add":"Modaldata_dropdown_add__8JCVd","form_group":"Modaldata_form_group__OlPgJ"};